<template>
            <!-- Premium and essential services -->
        <section class="premium-and-essential-services">
            <div class="preminum-float-bg">
                <img src="@/assets/img/bg/premium-bg.png" alt="">
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="premium-header text-center aos" data-aos="fade-up">
                            <h2>Premium and essential services in Listee, contributing to enhancing residents' life experience</h2>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 aos" data-aos="fade-up" data-aos-delay="200">
						<div class="listee-premium">
							<div class="listee-premium-img">
								<span><img src="@/assets/img/icons/service-1.svg" alt="img"></span>
							</div>
							<div class="listee-premium-content">
								<h6>Add your listing</h6>
								<p>Lorem Ipsum is simply dummy text printing and type setting industry</p>
							</div>
						</div>
					</div>
                    <div class="col-lg-4 col-sm-6 aos" data-aos="fade-up" data-aos-delay="400">
						<div class="listee-premium">
							<div class="listee-premium-img">
								<span><img src="@/assets/img/icons/service-2.svg" alt="img"></span>
							</div>
							<div class="listee-premium-content">
								<h6>Easy Finance</h6>
								<p>Lorem Ipsum is simply dummy text printing and type setting industry</p>
							</div>
						</div>
					</div>
                    <div class="col-lg-4 col-sm-6 aos" data-aos="fade-up" data-aos-delay="600">
						<div class="listee-premium">
							<div class="listee-premium-img">
								<span><img src="@/assets/img/icons/service-3.svg" alt="img"></span>
							</div>
							<div class="listee-premium-content">
								<h6>Publish your listing</h6>
								<p>Lorem Ipsum is simply dummy text printing and type setting industry</p>
							</div>
						</div>
					</div>
                    <div class="col-lg-4 col-sm-6 aos" data-aos="fade-up" data-aos-delay="200">
						<div class="listee-premium bottom-list-premium ">
							<div class="listee-premium-img">
								<span><img src="@/assets/img/icons/service-4.svg" alt="img"></span>
							</div>
							<div class="listee-premium-content">
								<h6>Register for free</h6>
								<p>Lorem Ipsum is simply dummy text printing and type setting industry</p>
							</div>
						</div>
					</div>
                    <div class="col-lg-4 col-sm-6 aos" data-aos="fade-up" data-aos-delay="400">
						<div class="listee-premium bottom-list-premium ">
							<div class="listee-premium-img">
								<span><img src="@/assets/img/icons/service-5.svg" alt="img"></span>
							</div>
							<div class="listee-premium-content">
								<h6>Get reservations</h6>
								<p>Lorem Ipsum is simply dummy text printing and type setting industry</p>
							</div>
						</div>
					</div>
                    <div class="col-lg-4 col-sm-6 aos" data-aos="fade-up" data-aos-delay="600">
						<div class="listee-premium bottom-list-premium ">
							<div class="listee-premium-img">
								<span><img src="@/assets/img/icons/service-6.svg" alt="img"></span>
							</div>
							<div class="listee-premium-content">
								<h6>Upload beautiful images</h6>
								<p>Lorem Ipsum is simply dummy text printing and type setting industry</p>
							</div>
						</div>
					</div>
                </div>
            </div>
        </section>
        <!-- /Premium and essential services -->

        <!-- Make It Easy -->
        <section class="make-it-easy ">
            <div class="container">
                <h2 class="mb-0">We make it easy to find your perfect fit with over a million available rentals.</h2>
                <p>Circumstances certain circumstances and owing.</p>
                <router-link to="categories">Search Properties</router-link>
            </div>
        </section>
        <!-- /Make It Easy -->
    </template>